if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        var discount = 0;
        if (
          $(".product__info-wrapper").find(".discountpercentage").length > 0
        ) {
          discount = Number(
            $(".product__info-wrapper").find(".discountpercentage").html()
          );
        }
        console.log("discount==" + discount);
        var discountperc = discount;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        // CD CODE
        var checked_pro = false;
        var upsell_variant_html = "";
        document
          .querySelector(".custom_cart_notification")
          .classList.remove("notification_is_open");
        if(this.closest(".product")){
          if (
            this.closest(".product").querySelectorAll(
              ".upsell_product .upsell_checkbox:checked"
            ).length
          ) {
            var upsell_id =
              this.closest(".product").querySelectorAll(".upsell_product");
  
            if (
              this.closest(".product")
                .querySelector(".current_upsell_qty")
                .getAttribute("data-quantity") != null
            ) {
              var upsell_quantity = this.closest(".product")
                .querySelector(".upsell_checkbox_text .current_upsell_qty")
                .getAttribute("data-quantity");
            } else {
              var upsell_quantity = 1;
            }
  
            var upsell_item = [];
            var up_formData = {
              items: upsell_item,
            };
            upsell_id.forEach(function (item) {
              if (item.querySelector("input.upsell_checkbox:checked") != null) {
                if (
                  item
                    .querySelector(".upsell_checkbox_text")
                    .getAttribute("data-handle") == "cube-stand"
                ) {
                  upsell_item.push({
                    id: item
                      .querySelector("input.upsell_checkbox:checked")
                      .closest(".upsell_product")
                      .querySelector(".upsell_checkbox_text")
                      .getAttribute("data-id"),
                    quantity: upsell_quantity,
                  });
                } else {
                  upsell_item.push({
                    id: item
                      .querySelector("input.upsell_checkbox:checked")
                      .closest(".upsell_product")
                      .querySelector(".upsell_checkbox_text")
                      .getAttribute("data-id"),
                    quantity: 1,
                  });
                }
                checked_pro = true;
              }
            });
          }
        }
        var current_qty = 0;

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");

            // CD CODE cart notification add raguler item
            // document.querySelector('.custom_cart_notification .cart_add_product_list.upsell_items').style.display = 'none';

            if (this.closest(".product") != null && checked_pro == true) {
              fetch(`${routes.cart_add_url}.js`, {
                method: "POST",
                body: JSON.stringify(up_formData),
                headers: {
                  "Content-Type": "application/json",
                },
              })
                .then((res) => res.json())
                .then((data) => {
                  document
                    .querySelectorAll(".cart_add_product_list.upsell_items")
                    .forEach(function (remove_item) {
                      remove_item.remove();
                    });
                  data.items.forEach(function (item) {
                    upsell_variant_html = "";
                    if (item.variant_title != null) {
                      upsell_variant_html =
                        '<p class="cart_list_variant">Size: <span class="cart_list_pro_variant">' +
                        item.variant_title +
                        "</span></p>";
                    }
                    var price = item.price;
                    var compprice = item.compare_at_price;
                    if (discountperc > 0) {
                      price = (price * discountperc) / 100;
                      compprice = item.price;
                    }

                    var custom_html =
                      '<div class="cart_add_product_list upsell_items" data-id="' +
                      item.id +
                      '" data-price="' +
                      price +
                      '"><div class="cart_product_info"> <div class="cart_product_image"> <img src="' +
                      item.featured_image.url +
                      '"> </div> <div class="info_cart_pro"> <h1 class="cart_list_pro_title">' +
                      item.product_title +
                      '</h1><p><span class="cart_list_pro_price">' +
                      Shopify.formatMoney(
                        price,
                        document.querySelector("body").getAttribute("shop")
                      ) +
                      "</span>" +
                      "</p>" +
                      upsell_variant_html +
                      ' <div class="cart_list_pro_qantity"> <div class="qtybox"> <span class="btnqty qtyminus icon icon-minus" docapp-data-protected="no-id">-</span> <input type="text" id="Quantity-header" value="' +
                      item.quantity +
                      '" min="1" pattern="[0-9]*" class="product-form__input product-form__input--quantity quantity-selector quantity-input" data-quantity-input="" docapp-data-protected="no-id"> <span class="btnqty qtyplus icon icon-plus" docapp-data-protected="no-id">+</span> </div> <button class="remove_cart_product" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove"> <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path> <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path> </svg> </button> </div> </div> </div> <div class="cart_product_total_price">' +
                      Shopify.formatMoney(
                       price * item.quantity,
                        document.querySelector("body").getAttribute("shop")
                      ) +
                      "</div> </div>";
                    if (compprice > price) {
                      custom_html =
                        '<div class="cart_add_product_list upsell_items" data-id="' +
                        item.id +
                        '" data-price="' +
                        price +
                        '"><div class="cart_product_info"> <div class="cart_product_image"> <img src="' +
                        item.featured_image.url +
                        '"> </div> <div class="info_cart_pro"> <h1 class="cart_list_pro_title">' +
                        item.product_title +
                        '</h1><p><span class="cart_list_pro_price">' +
                        Shopify.formatMoney(
                          price,
                          document.querySelector("body").getAttribute("shop")
                        ) +
                        "</span>" +
                        '<span class="cart_list_cmp_price">' +
                        Shopify.formatMoney(
                          compprice,
                          document.querySelector("body").getAttribute("shop")
                        ) +
                        "</span>" +
                        '<span class="cart_price__badge-sale">' +
                        "Save " +
                        Shopify.formatMoney(
                          compprice - price,
                          document.querySelector("body").getAttribute("shop")
                        ) +
                        "</span>" +
                        "</p>" +
                        upsell_variant_html +
                        ' <div class="cart_list_pro_qantity"> <div class="qtybox"> <span class="btnqty qtyminus icon icon-minus" docapp-data-protected="no-id">-</span> <input type="text" id="Quantity-header" value="' +
                        item.quantity +
                        '" min="1" pattern="[0-9]*" class="product-form__input product-form__input--quantity quantity-selector quantity-input" data-quantity-input="" docapp-data-protected="no-id"> <span class="btnqty qtyplus icon icon-plus" docapp-data-protected="no-id">+</span> </div> <button class="remove_cart_product" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove"> <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path> <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path> </svg> </button> </div> </div> </div> <div class="cart_product_total_price">' +
                        Shopify.formatMoney(
                          item.price * item.quantity,
                          document.querySelector("body").getAttribute("shop")
                        ) +
                        "</div> </div>";
                    }
                    document.querySelector(
                      ".custom_cart_notification .cart_pro_list"
                    ).innerHTML += custom_html;
                  });

                  document.querySelector(
                    ".custom_cart_notification .cart_add_product_list.regular_item .cart_product_total_price"
                  ).innerHTML = Shopify.formatMoney(
                    price * response.quantity,
                    document.querySelector("body").getAttribute("shop")
                  );
                  document.querySelector(
                    ".custom_cart_notification .cart_add_product_list.regular_item .info_cart_pro .cart_list_pro_qantity #Quantity-header"
                  ).value = response.quantity;

                  var getJSON = function (url) {
                    var xhr = new XMLHttpRequest();
                    xhr.open("GET", url, true);
                    xhr.responseType = "json";
                    xhr.onload = function () {
                      var status = xhr.status;
                      document.querySelector(
                        ".cart-count-bubble span:first-child"
                      ).innerHTML = xhr.response.item_count;
                      document.querySelector(
                        ".cart-count-bubble span:last-child"
                      ).innerHTML = xhr.response.item_count + "items";
                      if (
                        document.querySelectorAll("#cart-notification-button")
                          .length
                      ) {
                        document.querySelector(
                          "#cart-notification-button"
                        ).innerHTML =
                          "View my cart (" + xhr.response.item_count + ")";
                      }
                      document.querySelector(
                        ".custom_cart_notification .total_quantitys"
                      ).innerHTML = xhr.response.item_count;
                      document.querySelector(
                        ".custom_cart_notification .cart_notification_footer .cart_notification_totalprice"
                      ).innerHTML = Shopify.formatMoney(
                        xhr.response.total_price,
                        document.querySelector("body").getAttribute("shop")
                      );
                    };
                    xhr.send();
                  };

                  getJSON("/cart.js");
                })
                .catch((error) => {
                  console.error(`error ${error}`);
                });
              // current_qty = (current_qty + parseInt(this.closest('.product').querySelector('.product-form__quantity .quantity__input').value));
            } else {
              var getJSON = function (url) {
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, true);
                xhr.responseType = "json";
                xhr.onload = function () {
                  var status = xhr.status;
                  document.querySelector(
                    ".cart-count-bubble span:first-child"
                  ).innerHTML = xhr.response.item_count;
                  document.querySelector(
                    ".cart-count-bubble span:last-child"
                  ).innerHTML = xhr.response.item_count + "items";
                  if (
                    document.querySelectorAll("#cart-notification-button")
                      .length
                  ) {
                    document.querySelector(
                      "#cart-notification-button"
                    ).innerHTML =
                      "View my cart (" + xhr.response.item_count + ")";
                  }
                  document.querySelector(
                    ".custom_cart_notification .total_quantitys"
                  ).innerHTML = xhr.response.item_count;
                  document.querySelector(
                    ".custom_cart_notification .cart_notification_footer .cart_notification_totalprice"
                  ).innerHTML = Shopify.formatMoney(
                    xhr.response.total_price,
                    document.querySelector("body").getAttribute("shop")
                  );
                };
                xhr.send();
              };

              getJSON("/cart.js");
              // document.querySelector('.custom_cart_notification .total_quantitys').innerHTML = response.quantity;
              document.querySelector(
                ".custom_cart_notification .cart_add_product_list.regular_item .cart_product_total_price"
              ).innerHTML = Shopify.formatMoney(
                response.price * response.quantity,
                document.querySelector("body").getAttribute("shop")
              );
            }

            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            // if(this.closest('.product') != null){
            //   current_qty = (current_qty + parseInt(this.closest('.product').querySelector('.product-form__quantity .quantity__input').value));
            // }else{
            //   current_qty = 1
            // }

            document.querySelector(
              ".custom_cart_notification .cart_add_product_list.regular_item"
            ).style.display = "flex";
            // document.querySelector('.custom_cart_notification .total_quantitys').innerHTML = current_qty;
            document
              .querySelector(
                ".custom_cart_notification .cart_add_product_list.regular_item .cart_product_image img"
              )
              .setAttribute("src", response.featured_image.url);
            console.log(response)
                       
            document.querySelector(
              ".custom_cart_notification .cart_add_product_list.regular_item .info_cart_pro .cart_list_pro_title"
            ).innerHTML = response.product_title;
            document.querySelector(
              ".custom_cart_notification .cart_add_product_list.regular_item .info_cart_pro .cart_list_pro_price"
            ).innerHTML = Shopify.formatMoney(
              response.line_price,
              document.querySelector("body").getAttribute("shop")
            );
            if(response.line_level_total_discount > 0){
            document.querySelector(
              ".custom_cart_notification .cart_add_product_list.regular_item .info_cart_pro .cart_list_cmp_price"
            ).innerHTML = Shopify.formatMoney(
              response.original_line_price,
              document.querySelector("body").getAttribute("shop")
            );
            document.querySelector(
              ".custom_cart_notification .cart_add_product_list.regular_item .info_cart_pro .cart_price__badge-sale"
            ).innerHTML =
              "Save " +
              Shopify.formatMoney(
                response.line_level_total_discount,
                document.querySelector("body").getAttribute("shop")
              );
               document.querySelector(
              ".custom_cart_notification .cart_add_product_list.regular_item .info_cart_pro .cart_price__badge-sale"
              ).style.display = "block"
            }else{
              document.querySelector(
              ".custom_cart_notification .cart_add_product_list.regular_item .info_cart_pro .cart_price__badge-sale"
              ).style.display = "none"
            }
            if (response.variant_title != null) {
              document.querySelector(
                ".custom_cart_notification .cart_add_product_list.regular_item .info_cart_pro .cart_list_variant"
              ).style.display = "block";
              document.querySelector(
                ".custom_cart_notification .cart_add_product_list.regular_item .info_cart_pro .cart_list_pro_variant"
              ).innerHTML = response.variant_title;
            } else {
              document.querySelector(
                ".custom_cart_notification .cart_add_product_list.regular_item .info_cart_pro .cart_list_variant"
              ).style.display = "none";
            }
            document.querySelector(
              ".custom_cart_notification .cart_add_product_list.regular_item .info_cart_pro .cart_list_pro_qantity #Quantity-header"
            ).value = response.quantity;
            document
              .querySelector(
                ".custom_cart_notification .cart_add_product_list.regular_item"
              )
              .setAttribute("data-id", response.id);
            document
              .querySelector(
                ".custom_cart_notification .cart_add_product_list.regular_item"
              )
              .setAttribute("data-price", response.price);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            // CD CODE
            document
              .querySelector(".custom_cart_notification")
              .classList.add("notification_is_open");
            window.scrollTo({ top: 0, behavior: "smooth" });
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
